export const blockIconsCommonactionsCalendarMonthNew = (
	<span className='material-symbols-outlined'>calendar_month</span>
);
